import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Logo";
import { EMAIL } from "@/lib/site";

const SECTIONS = [
    {
        title: "1. Verantwortlicher",
        body: "KischioWood — Hannes Kischio, Neu Placht 4E, 17268 Templin, Telefon +49 151 20707720, E-Mail kischio@yahoo.de.",
    },
    {
        title: "2. Datenerhebung auf dieser Website",
        body: "Beim Absenden des Kontaktformulars werden Name, E-Mail-Adresse, Adresse, Telefonnummer (freiwillig) und Ihre Nachricht verarbeitet, um Ihre Anfrage zu bearbeiten (Art. 6 Abs. 1 lit. b DSGVO). Bewertungen werden mit Ihrem Namen und ggf. Foto veröffentlicht. Eine Weitergabe an Dritte erfolgt nicht. Zur Verbesserung der Website werden Seitenaufrufe anonymisiert und ohne Cookies gezählt (keine personenbezogenen Daten, keine IP-Speicherung). Technisch notwendige Cookies werden nur im geschützten Admin-Login verwendet.",
    },
    {
        title: "3. E-Mail-Versand",
        body: "Zur Zustellung Ihrer Anfrage und von Bestätigungs-Mails wird ein E-Mail-Dienstleister eingesetzt. Ihre Daten werden ausschließlich zur Abwicklung der Kommunikation genutzt.",
    },
    {
        title: "4. Speicherdauer",
        body: "Anfragen werden nur so lange gespeichert, wie es für die Bearbeitung und etwaige Folgekommunikation erforderlich ist, und anschließend gelöscht.",
    },
    {
        title: "5. Ihre Rechte",
        body: `Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer Daten sowie auf Datenübertragbarkeit. Wenden Sie sich dazu einfach an ${EMAIL}. Zudem besteht ein Beschwerderecht bei der zuständigen Aufsichtsbehörde.`,
    },
];

export default function Datenschutz() {
    return (
        <div className="min-h-screen bg-[#120E09] px-6 py-16" data-testid="datenschutz-page">
            <div className="mx-auto max-w-2xl">
                <Link to="/" aria-label="Zur Startseite"><Logo size={64} /></Link>
                <h1 className="mt-12 mb-10 font-display text-4xl font-extrabold uppercase tracking-tight text-[#EDE6DA]">Datenschutz</h1>
                <div className="space-y-8 rounded border border-[#2E2517] bg-[#1B150E] p-8 text-sm leading-relaxed text-[#D9D2C4]">
                    <p className="text-[#9C917D]">Datenschutzerklärung gemäß DSGVO — KischioWood</p>
                    {SECTIONS.map((s) => (
                        <div key={s.title}>
                            <h2 className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#C88A45]">{s.title}</h2>
                            <p>{s.body}</p>
                        </div>
                    ))}
                </div>
                <Link to="/" data-testid="datenschutz-back-link" className="mt-10 inline-block text-xs text-[#9C917D] transition-colors duration-200 hover:text-[#C88A45]">
                    ← Zurück zur Website
                </Link>
            </div>
        </div>
    );
}
